import React from "react";
import { FaArrowRight, FaBalanceScale, FaChartLine, FaRobot } from "react-icons/fa";
import Logo from "../../assets/logo.png";

function Banner() {
  const highlights = [
    "Automacao juridica integrada",
    "Controle financeiro e operacional",
    "IA aplicada a produtividade",
  ];

  return (
    <section className="banner-presentation min-vh-100 position-relative overflow-hidden d-flex align-items-center">
      <div className="container presentation-shell px-4 px-lg-5 position-relative z-1 py-5">
        <div className="row align-items-center gy-5">
          <div className="col-lg-6 text-center text-lg-start">
            <span className="section-kicker animate__animated animate__fadeInUp">
              Plataforma juridica premium
            </span>

            <h1 className="display-2 fw-bold mb-4 text-dark animate__animated animate__fadeInUp animate__delay-1s">
              Gestao juridica moderna para
              <span className="d-block text-gold">escritorios que querem escalar</span>
            </h1>

            <p className="lead mb-4 text-secondary banner-description animate__animated animate__fadeInUp animate__delay-1s">
              Centralize processos, clientes, financeiro, timesheet e inteligencia
              artificial em uma unica experiencia. Tudo com visual premium,
              operacao clara e mais velocidade no dia a dia.
            </p>

            <div className="d-flex flex-wrap gap-2 mb-5 justify-content-center justify-content-lg-start animate__animated animate__fadeInUp animate__delay-2s">
              {highlights.map((item) => (
                <span key={item} className="banner-chip">
                  {item}
                </span>
              ))}
            </div>

            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start animate__animated animate__fadeInUp animate__delay-2s">
              <a
                href="https://www.easyvogplanos.com/"
                target="_blank"
                rel="noreferrer"
                className="btn btn-gold"
              >
                Experimente gratis
                <FaArrowRight />
              </a>
              <a href="#video" className="btn btn-outline-premium">
                Ver demonstracao
              </a>
            </div>

            <div className="row g-3 mt-4 animate__animated animate__fadeInUp animate__delay-2s">
              <div className="col-6 col-md-4">
                <div className="banner-stat-card">
                  <strong>+2M</strong>
                  <span>movimentacoes acompanhadas</span>
                </div>
              </div>
              <div className="col-6 col-md-4">
                <div className="banner-stat-card">
                  <strong>24/7</strong>
                  <span>operacao acessivel em nuvem</span>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="banner-stat-card">
                  <strong>IA</strong>
                  <span>apoio real na produtividade juridica</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 animate__animated animate__fadeInRight animate__delay-1s">
            <div className="hero-visual-shell mx-auto">
              <div className="hero-dashboard-card hero-dashboard-main">
                <div className="hero-dashboard-top">
                  <div>
                    <span className="hero-eyebrow">EasyVOG Workspace</span>
                    <h3>Painel estrategico do escritorio</h3>
                  </div>
                  <img src={Logo} alt="logotipo easy vog" className="img-fluid hero-logo drop-shadow-gold" />
                </div>

                <div className="hero-dashboard-grid">
                  <div className="hero-insight-card">
                    <FaBalanceScale className="text-gold fs-4" />
                    <div>
                      <strong>Prazos centralizados</strong>
                      <span>Alertas, andamentos e agenda sincronizados.</span>
                    </div>
                  </div>

                  <div className="hero-insight-card">
                    <FaChartLine className="text-gold fs-4" />
                    <div>
                      <strong>Financeiro claro</strong>
                      <span>Receitas, despesas e rentabilidade em tempo real.</span>
                    </div>
                  </div>

                  <div className="hero-insight-card hero-insight-card-wide">
                    <FaRobot className="text-gold fs-4" />
                    <div>
                      <strong>IA aplicada a rotina juridica</strong>
                      <span>Estruture pecas, resumos e analises com apoio inteligente.</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="hero-floating-card hero-floating-card-top">
                <span>Performance</span>
                <strong>+38%</strong>
                <small>mais agilidade operacional</small>
              </div>

              <div className="hero-floating-card hero-floating-card-bottom">
                <span>Experiencia</span>
                <strong>Premium</strong>
                <small>visual elegante e responsivo</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="position-absolute top-0 end-0 bg-gold-glow rounded-circle blur-3xl opacity-25 banner-glow banner-glow-top"></div>
      <div className="position-absolute bottom-0 start-0 bg-gold-glow rounded-circle blur-3xl opacity-25 banner-glow banner-glow-bottom"></div>
    </section>
  );
}

export default Banner;
